/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { BodyType, ErrorType } from "../../apix-handler";
import type {
  AccountingCustomerOptionsResponse,
  AccountingLinkingAccountingImportOptionsGetV2Params,
  AccountingLinkingMassLinkEntityGetV2Params,
  AccountingLinkingOptions,
  GetImportFromAccountingResponse,
  GetMassLinkResponse,
  IDTypes,
  LinkJobToAccountingJobLoadResponse,
  MassAccountingLinkRequest,
  PutImportFromAccountingResponse,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const accountingLinkingCustomerOptionsGetV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<AccountingCustomerOptionsResponse>(
    {
      url: `/apix/v2/AccountingLinking/customer-options`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getAccountingLinkingCustomerOptionsGetV2QueryKey = () => {
  return [`/apix/v2/AccountingLinking/customer-options`] as const;
};

export const getAccountingLinkingCustomerOptionsGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof accountingLinkingCustomerOptionsGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof accountingLinkingCustomerOptionsGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAccountingLinkingCustomerOptionsGetV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof accountingLinkingCustomerOptionsGetV2>>
  > = ({ signal }) =>
    accountingLinkingCustomerOptionsGetV2(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof accountingLinkingCustomerOptionsGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AccountingLinkingCustomerOptionsGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof accountingLinkingCustomerOptionsGetV2>>
>;
export type AccountingLinkingCustomerOptionsGetV2QueryError =
  ErrorType<unknown>;

export function useAccountingLinkingCustomerOptionsGetV2<
  TData = Awaited<ReturnType<typeof accountingLinkingCustomerOptionsGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof accountingLinkingCustomerOptionsGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getAccountingLinkingCustomerOptionsGetV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const accountingLinkingAccountingImportOptionsGetV2 = (
  params?: AccountingLinkingAccountingImportOptionsGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<GetImportFromAccountingResponse>(
    {
      url: `/apix/v2/AccountingLinking/accounting-import-options`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getAccountingLinkingAccountingImportOptionsGetV2QueryKey = (
  params?: AccountingLinkingAccountingImportOptionsGetV2Params,
) => {
  return [
    `/apix/v2/AccountingLinking/accounting-import-options`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAccountingLinkingAccountingImportOptionsGetV2QueryOptions = <
  TData = Awaited<
    ReturnType<typeof accountingLinkingAccountingImportOptionsGetV2>
  >,
  TError = ErrorType<unknown>,
>(
  params?: AccountingLinkingAccountingImportOptionsGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof accountingLinkingAccountingImportOptionsGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAccountingLinkingAccountingImportOptionsGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof accountingLinkingAccountingImportOptionsGetV2>>
  > = ({ signal }) =>
    accountingLinkingAccountingImportOptionsGetV2(
      params,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof accountingLinkingAccountingImportOptionsGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AccountingLinkingAccountingImportOptionsGetV2QueryResult =
  NonNullable<
    Awaited<ReturnType<typeof accountingLinkingAccountingImportOptionsGetV2>>
  >;
export type AccountingLinkingAccountingImportOptionsGetV2QueryError =
  ErrorType<unknown>;

export function useAccountingLinkingAccountingImportOptionsGetV2<
  TData = Awaited<
    ReturnType<typeof accountingLinkingAccountingImportOptionsGetV2>
  >,
  TError = ErrorType<unknown>,
>(
  params?: AccountingLinkingAccountingImportOptionsGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof accountingLinkingAccountingImportOptionsGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getAccountingLinkingAccountingImportOptionsGetV2QueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const accountingLinkingMassLinkEntityGetV2 = (
  params?: AccountingLinkingMassLinkEntityGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<GetMassLinkResponse>(
    {
      url: `/apix/v2/AccountingLinking/mass-link-entity`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getAccountingLinkingMassLinkEntityGetV2QueryKey = (
  params?: AccountingLinkingMassLinkEntityGetV2Params,
) => {
  return [
    `/apix/v2/AccountingLinking/mass-link-entity`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAccountingLinkingMassLinkEntityGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof accountingLinkingMassLinkEntityGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: AccountingLinkingMassLinkEntityGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof accountingLinkingMassLinkEntityGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAccountingLinkingMassLinkEntityGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof accountingLinkingMassLinkEntityGetV2>>
  > = ({ signal }) =>
    accountingLinkingMassLinkEntityGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof accountingLinkingMassLinkEntityGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AccountingLinkingMassLinkEntityGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof accountingLinkingMassLinkEntityGetV2>>
>;
export type AccountingLinkingMassLinkEntityGetV2QueryError = ErrorType<unknown>;

export function useAccountingLinkingMassLinkEntityGetV2<
  TData = Awaited<ReturnType<typeof accountingLinkingMassLinkEntityGetV2>>,
  TError = ErrorType<unknown>,
>(
  params?: AccountingLinkingMassLinkEntityGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof accountingLinkingMassLinkEntityGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAccountingLinkingMassLinkEntityGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const accountingLinkingMassLinkEntityPutV2 = (
  massAccountingLinkRequest: BodyType<MassAccountingLinkRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    {
      url: `/apix/v2/AccountingLinking/mass-link-entity`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: massAccountingLinkRequest,
    },
    options,
  );
};

export const getAccountingLinkingMassLinkEntityPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountingLinkingMassLinkEntityPutV2>>,
    TError,
    { data: BodyType<MassAccountingLinkRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountingLinkingMassLinkEntityPutV2>>,
  TError,
  { data: BodyType<MassAccountingLinkRequest> },
  TContext
> => {
  const mutationKey = ["accountingLinkingMassLinkEntityPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountingLinkingMassLinkEntityPutV2>>,
    { data: BodyType<MassAccountingLinkRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return accountingLinkingMassLinkEntityPutV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AccountingLinkingMassLinkEntityPutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof accountingLinkingMassLinkEntityPutV2>>
>;
export type AccountingLinkingMassLinkEntityPutV2MutationBody =
  BodyType<MassAccountingLinkRequest>;
export type AccountingLinkingMassLinkEntityPutV2MutationError =
  ErrorType<unknown>;

export const useAccountingLinkingMassLinkEntityPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountingLinkingMassLinkEntityPutV2>>,
    TError,
    { data: BodyType<MassAccountingLinkRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof accountingLinkingMassLinkEntityPutV2>>,
  TError,
  { data: BodyType<MassAccountingLinkRequest> },
  TContext
> => {
  const mutationOptions =
    getAccountingLinkingMassLinkEntityPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const accountingLinkingProjectLinksByCustomerIdAndJobIdAndIncludeCreateNewEntityOptionGetV2 =
  (
    customerId: string,
    jobId: number,
    includeCreateNewEntityOption: boolean,
    options?: SecondParameter<typeof apixHandler>,
    signal?: AbortSignal,
  ) => {
    return apixHandler<LinkJobToAccountingJobLoadResponse>(
      {
        url: `/apix/v2/AccountingLinking/project-links/${customerId}/${jobId}/${includeCreateNewEntityOption}`,
        method: "GET",
        signal,
      },
      options,
    );
  };

export const getAccountingLinkingProjectLinksByCustomerIdAndJobIdAndIncludeCreateNewEntityOptionGetV2QueryKey =
  (
    customerId?: string,
    jobId?: number,
    includeCreateNewEntityOption?: boolean,
  ) => {
    return [
      `/apix/v2/AccountingLinking/project-links/${customerId}/${jobId}/${includeCreateNewEntityOption}`,
    ] as const;
  };

export const getAccountingLinkingProjectLinksByCustomerIdAndJobIdAndIncludeCreateNewEntityOptionGetV2QueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof accountingLinkingProjectLinksByCustomerIdAndJobIdAndIncludeCreateNewEntityOptionGetV2
      >
    >,
    TError = ErrorType<unknown>,
  >(
    customerId: string,
    jobId: number,
    includeCreateNewEntityOption: boolean,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            typeof accountingLinkingProjectLinksByCustomerIdAndJobIdAndIncludeCreateNewEntityOptionGetV2
          >
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apixHandler>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getAccountingLinkingProjectLinksByCustomerIdAndJobIdAndIncludeCreateNewEntityOptionGetV2QueryKey(
        customerId,
        jobId,
        includeCreateNewEntityOption,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof accountingLinkingProjectLinksByCustomerIdAndJobIdAndIncludeCreateNewEntityOptionGetV2
        >
      >
    > = ({ signal }) =>
      accountingLinkingProjectLinksByCustomerIdAndJobIdAndIncludeCreateNewEntityOptionGetV2(
        customerId,
        jobId,
        includeCreateNewEntityOption,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(customerId && jobId && includeCreateNewEntityOption),
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof accountingLinkingProjectLinksByCustomerIdAndJobIdAndIncludeCreateNewEntityOptionGetV2
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type AccountingLinkingProjectLinksByCustomerIdAndJobIdAndIncludeCreateNewEntityOptionGetV2QueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof accountingLinkingProjectLinksByCustomerIdAndJobIdAndIncludeCreateNewEntityOptionGetV2
      >
    >
  >;
export type AccountingLinkingProjectLinksByCustomerIdAndJobIdAndIncludeCreateNewEntityOptionGetV2QueryError =
  ErrorType<unknown>;

export function useAccountingLinkingProjectLinksByCustomerIdAndJobIdAndIncludeCreateNewEntityOptionGetV2<
  TData = Awaited<
    ReturnType<
      typeof accountingLinkingProjectLinksByCustomerIdAndJobIdAndIncludeCreateNewEntityOptionGetV2
    >
  >,
  TError = ErrorType<unknown>,
>(
  customerId: string,
  jobId: number,
  includeCreateNewEntityOption: boolean,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          typeof accountingLinkingProjectLinksByCustomerIdAndJobIdAndIncludeCreateNewEntityOptionGetV2
        >
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getAccountingLinkingProjectLinksByCustomerIdAndJobIdAndIncludeCreateNewEntityOptionGetV2QueryOptions(
      customerId,
      jobId,
      includeCreateNewEntityOption,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const accountingLinkingAccountingLinkingOptionsByEntityIdAndIdTypeGetV2 =
  (
    entityId: number,
    idType: IDTypes,
    options?: SecondParameter<typeof apixHandler>,
    signal?: AbortSignal,
  ) => {
    return apixHandler<AccountingLinkingOptions>(
      {
        url: `/apix/v2/AccountingLinking/accounting-linking-options/${entityId}/${idType}`,
        method: "GET",
        signal,
      },
      options,
    );
  };

export const getAccountingLinkingAccountingLinkingOptionsByEntityIdAndIdTypeGetV2QueryKey =
  (entityId?: number, idType?: IDTypes) => {
    return [
      `/apix/v2/AccountingLinking/accounting-linking-options/${entityId}/${idType}`,
    ] as const;
  };

export const getAccountingLinkingAccountingLinkingOptionsByEntityIdAndIdTypeGetV2QueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof accountingLinkingAccountingLinkingOptionsByEntityIdAndIdTypeGetV2
      >
    >,
    TError = ErrorType<unknown>,
  >(
    entityId: number,
    idType: IDTypes,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            typeof accountingLinkingAccountingLinkingOptionsByEntityIdAndIdTypeGetV2
          >
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apixHandler>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getAccountingLinkingAccountingLinkingOptionsByEntityIdAndIdTypeGetV2QueryKey(
        entityId,
        idType,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof accountingLinkingAccountingLinkingOptionsByEntityIdAndIdTypeGetV2
        >
      >
    > = ({ signal }) =>
      accountingLinkingAccountingLinkingOptionsByEntityIdAndIdTypeGetV2(
        entityId,
        idType,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(entityId && idType),
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof accountingLinkingAccountingLinkingOptionsByEntityIdAndIdTypeGetV2
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type AccountingLinkingAccountingLinkingOptionsByEntityIdAndIdTypeGetV2QueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof accountingLinkingAccountingLinkingOptionsByEntityIdAndIdTypeGetV2
      >
    >
  >;
export type AccountingLinkingAccountingLinkingOptionsByEntityIdAndIdTypeGetV2QueryError =
  ErrorType<unknown>;

export function useAccountingLinkingAccountingLinkingOptionsByEntityIdAndIdTypeGetV2<
  TData = Awaited<
    ReturnType<
      typeof accountingLinkingAccountingLinkingOptionsByEntityIdAndIdTypeGetV2
    >
  >,
  TError = ErrorType<unknown>,
>(
  entityId: number,
  idType: IDTypes,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          typeof accountingLinkingAccountingLinkingOptionsByEntityIdAndIdTypeGetV2
        >
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getAccountingLinkingAccountingLinkingOptionsByEntityIdAndIdTypeGetV2QueryOptions(
      entityId,
      idType,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const accountingLinkingImportFromAccountingPutV2 = (
  massAccountingLinkRequest: BodyType<MassAccountingLinkRequest>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<PutImportFromAccountingResponse>(
    {
      url: `/apix/v2/AccountingLinking/import-from-accounting`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: massAccountingLinkRequest,
    },
    options,
  );
};

export const getAccountingLinkingImportFromAccountingPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountingLinkingImportFromAccountingPutV2>>,
    TError,
    { data: BodyType<MassAccountingLinkRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountingLinkingImportFromAccountingPutV2>>,
  TError,
  { data: BodyType<MassAccountingLinkRequest> },
  TContext
> => {
  const mutationKey = ["accountingLinkingImportFromAccountingPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountingLinkingImportFromAccountingPutV2>>,
    { data: BodyType<MassAccountingLinkRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return accountingLinkingImportFromAccountingPutV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AccountingLinkingImportFromAccountingPutV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof accountingLinkingImportFromAccountingPutV2>>
  >;
export type AccountingLinkingImportFromAccountingPutV2MutationBody =
  BodyType<MassAccountingLinkRequest>;
export type AccountingLinkingImportFromAccountingPutV2MutationError =
  ErrorType<unknown>;

export const useAccountingLinkingImportFromAccountingPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountingLinkingImportFromAccountingPutV2>>,
    TError,
    { data: BodyType<MassAccountingLinkRequest> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof accountingLinkingImportFromAccountingPutV2>>,
  TError,
  { data: BodyType<MassAccountingLinkRequest> },
  TContext
> => {
  const mutationOptions =
    getAccountingLinkingImportFromAccountingPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
